import * as React from 'react'
import { Heading, HeadingProps } from '@chakra-ui/react'

const SectionHeader = (props: HeadingProps) => (
  <Heading as="h2" textAlign="center" size="lg" my="24px" {...props} />
)

export default SectionHeader
